import React from "react"
import PropTypes from "prop-types"

import { Base } from "ui-Text"
import ErrorBoundary from "ui-ErrorBoundary"

export const styleSheet = _theme => ({
  root: {
    display: "flex",
    flex: 1,
    maxHeight: "100%",
    maxWidth: "100%",
    flexDirection: "column",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
  },
})

class ScrollFrame extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    width: PropTypes.string,
  }

  state = {}

  render() {
    const { classes, className: classNameProp, children, ...otherProps } = this.props

    const className = classnames(classes.root, classNameProp)

    return (
      <Base {...otherProps} className={className} component="div">
        <ErrorBoundary>{children}</ErrorBoundary>
      </Base>
    )
  }
}

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export default withStyles(styleSheet)(ScrollFrame)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ScrollFrame/ScrollFrame.js